import { BaseContext } from '../../../utils/basecontext';
import { HttpClient } from '../../../utils/httpclient/httpclient';
import { POST, APIImpl } from '../api';
import { AddNameTuneRequest } from './addnametunerequest';
import { LanguageConst } from '../../../utils/resources/languageconst';

export class AddNameTuneNonLoggedInUserAPI extends APIImpl<AddNameTuneRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    { 
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/name-tune
        // return "name-tune";
        return "set-tone";
    }

    getRequestData(): string
    {
        return "msisdn="+ this.getRequest().getAddNameTuneRequest().getMsisdn()+"&"+
        "toneId="+ this.getRequest().getAddNameTuneRequest().getToneId()+"&"+
        "toneName="+ this.getRequest().getAddNameTuneRequest().getToneName()+"&"+
        "packName="+ this.getRequest().getAddNameTuneRequest().getPackName()+"&"+
        "channel="+ this.getRequest().getAddNameTuneRequest().getChannelId()+"&"+
        "username="+ this.getRequest().getAddNameTuneRequest().getUserName()+"&"+
        "language="+ (this.getRequest().getAddNameTuneRequest().getLanguage() === LanguageConst.ENGLISH ? "1": "2");
       
        // return "clientTxnId=27102020"+"&"+
        //        "language="+ this.getRequest().getAddNameTuneRequest().getLanguage()+"&"+
        //        "msisdn="+ this.getRequest().getAddNameTuneRequest().getMsisdn()+"&"+
        //        "toneId="+ this.getRequest().getAddNameTuneRequest().getToneId()+"&"+
        //        "packName="+ this.getRequest().getAddNameTuneRequest().getPackName()+"&"+
        //        "channelId="+ this.getRequest().getAddNameTuneRequest().getChannelId()+"&"+
        //        "toneName="+ this.getRequest().getAddNameTuneRequest().getToneName();
    }
}






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/nametune/addnametunenonloggedinuserapi.tsx